export const GENERATE_TICKET = "GENERATE_TICKET";
export const SAVE_REQUESTED_TESTS = "SAVE_REQUESTED_TESTS";
